module.exports = [
  require('./elizar_dryflagon'),
  require('./eternal_flame_guardian'),
  require('./eternal_flame_priest'),
]
